import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { PurchaseRequestService } from '../../services/purchase-request.service';
import { ProductCmpaService } from '../../services/product-cmpa.service';
import { toast, MaterializeAction } from 'angular2-materialize';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { Utils } from '../../util';
import { ProductionOrderService } from '../../services/production-order.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order.service';

@Component({
  selector: 'app-order-purchase-request',
  templateUrl: './order-purchase-request.component.html',
  styleUrls: ['./order-purchase-request.component.css']
})
export class OrderPurchaseRequestComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  requests: any[] = [];
  get allProducts(){ return this.requests.reduce((acc, cur) => [...acc, ...cur.products], []); }
  
  supplierSub: Subscription;

  constructor(
    private purchaseRequestService: PurchaseRequestService,
    private odcService: PurchaseOrderService,
    private prCmpaService: ProductCmpaService,
    private supplierService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private odpService: ProductionOrderService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
      permissionsSubs.unsubscribe();
      this.permission = this.permissionService.constructPermissionObject(groups, odcService.collection);
      if(!this.permission || !this.permission.createAction){
        toast('No tiene permiso para crear órdenes de compra.', 3000);
        this.router.navigate(['/']);
      }
      else this.allowed = true;
    });

    let requestSub = this.purchaseRequestService.getPurchaseRequests({excludeOrdered: true}).subscribe(purchaseRequests => {
      console.log('odr length', purchaseRequests.length);
      requestSub.unsubscribe();
      let sourceFolio='', sourcePrs=[];
      if(localStorage.prs){
        [sourceFolio, sourcePrs] = JSON.parse(localStorage.prs);
        delete localStorage.prs;
      }
      let lowestDate: string = Utils.today;
      this.requests = purchaseRequests.filter(({ordered, canceled, approved1, approved2}) => !canceled && !ordered && approved1 && approved2).map(({id, folio, date, deliveryRequiredDate: drdReq, productsInRequest, productionOrder: odpId, supplierRef, notes}) => {
        if(drdReq && drdReq < lowestDate) lowestDate = drdReq;
        let request = {
          id,
          folio,
          date,
          products: productsInRequest.map(({productRef: id, ordered, ...pr}, index) => !ordered && ({id, index, order: folio==sourceFolio && sourcePrs.includes(id), folioReq: folio, dateReq: date, drdReq, odpId, notes, ...pr}) ).filter(d => d),
          get order(){ return this.products.some(({order}) => order); }
        }
        if (odpId){
          let odpSub = this.odpService.getProductionOrder(odpId).subscribe(([odp]) => {
            odpSub.unsubscribe();
            for(let pr of request.products) pr.odpFolio = odp.name;
          });
        }
        if(supplierRef){
          let sub = this.supplierService.getCustomerSupplier(supplierRef.id).subscribe(supplier => {
            sub.unsubscribe();
            for(let pr of request.products) pr.supplierName = supplier.name;
          });
        }
        request.products.map(pr => {
          let sub = this.prCmpaService.getPrCmpa(pr.id).subscribe(([prCmpa]) => {
            sub.unsubscribe();
            let characs = prCmpa.characs.reduce((acc, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}`, '');
            pr.name = `${prCmpa.name} - ${characs}`;
          });
        });
        return request;
      });
      localStorage.odcLowestDate = lowestDate;
    });
    
    this.supplierSub = this.supplierService.getSuppliers().subscribe(suppliers => {
      this.readObjs[0] = {};
      this.rowsRead[0] = suppliers.map(supplier => {
        supplier.id = supplier.id$;
        this.readObjs[0][supplier.id] = {...supplier};
        return supplier;
      });
    });
    let fiscalDataSub = this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
      fiscalDataSub.unsubscribe();
    this.readObjs[1] = {};
      this.allFiscalRows = fiscalDatas.filter(fiscalData => {
        fiscalData.name = fiscalData.rfc;
        this.readObjs[1][fiscalData.id] = {...fiscalData};
        if(fiscalData.supplierId) return fiscalData;
      });
    });
  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.supplierSub && this.supplierSub.unsubscribe();
  }

  onOrder(){
    if(!Object.keys(this.productsToOrder).length) return toast('Seleccione un producto antes.', 3000);
    this.continueReadTo(0);
  }

  get productsToOrder(){
    return this.requests.reduce((acc, {products, ...cur}) =>{
      if(cur.order) acc[cur.id] = {products: products.filter(({order}) => order), ...cur};
      return acc;
    }, {} );
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      this.closeModalRead();
      localStorage.reqPrCmpas = JSON.stringify(this.productsToOrder);
      this.prCmpaService.router.navigate([`/new_purchase_order/${this.selectedIds[0]}_${this.selectedIds[1]}/${Object.keys(this.productsToOrder)[0]}`]);
    }else{
      if(nextIndex == 1) this.rowsRead[nextIndex] = this.allFiscalRows.filter(fiscalRow => fiscalRow.supplierId && fiscalRow.supplierId == this.selectedIds[0]);
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  subs: any[] = [];
  readPlaceholders = [ 'un proveedor', 'sus datos fiscales' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[], []];
  columnsRead = [
    [//supplier
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [
      { title: 'RFC', name: 'name', sort: 'asc' },
      { title: 'Razón Social', name: 'businessName' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.r_config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
